import { useState, useEffect } from 'react';
import { registerAndLoadRemote } from './register-and-load-remote';
import { fetchRemoteManifestData } from './fetch-remote-manifest-data';
export function useRemoteComponent({ appData, onInit, onLoaded }) {
    const { name, manifestFileName, rootModule, devServer } = appData;
    const [Component, setComponent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [hasError, setHasError] = useState(false);
    useEffect(() => {
        onInit?.(appData);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        let cancelled = false;
        async function load() {
            try {
                const manifest = await fetchRemoteManifestData(appData);
                if (cancelled) {
                    return;
                }
                if (!manifest) {
                    console.error('Failed to load remote component');
                    setHasError(true);
                    setLoading(false);
                    return;
                }
                const component = await registerAndLoadRemote(appData, manifest);
                if (cancelled) {
                    return;
                }
                if (!component) {
                    console.error('Failed to load remote component');
                    setHasError(true);
                    setLoading(false);
                    return;
                }
                onLoaded?.({
                    appData,
                    buildVersion: manifest.buildVersion
                });
                setComponent(() => component);
                setLoading(false);
            }
            catch (err) {
                if (cancelled) {
                    return;
                }
                console.error('Error loading remote component:', err);
                setHasError(true);
                setLoading(false);
            }
        }
        load();
        return () => {
            cancelled = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [devServer, manifestFileName, name, rootModule]);
    return { Component, loading, hasError };
}
//# sourceMappingURL=use-remote-component.hook.js.map